<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="!isNormalBookingFlow"
      [title]="page?.title"
      [showLinkIcon]="!isNormalBookingFlow"
      [linkIcon]="'trash'"
      (linkAction)="deleteAddress()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      @if (!isNormalBookingFlow) {
        <tidy-row [align]="'center'">
          <tidy-row>
            @if (address?.address_name) {
              <tidy-text
                [header]="address?.address_name + ' '"
                [translate]="false" />
            }
            @if (!address?.address_name) {
              <tidy-text
                [header]="address?.address1 + ' '"
                [translate]="false" />
              @if (address?.address2 !== null) {
                <tidy-text
                  [header]="address?.address2 + ' '"
                  [translate]="false" />
              }
            }
            <tidy-text
            [header]="address?.city +
            ', ' +
            address?.zip"
              [translate]="false" />
          </tidy-row>
        </tidy-row>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'This information is important to help your Pro get in, and never used for marketing. The more detail the better. Photos help a lot!'" />
      </tidy-row>
      @if (!form?.valid && showAlert) {
        <tidy-alert>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/alert.svg'" />
            <tidy-text
              [header]="alertHeader" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Details help jobs happen smoothly.'" />
          </tidy-row>
        </tidy-alert>
      }
      @if (isNormalBookingFlow && showPhoneEmailFields) {
        <tidy-card>
          <form [formGroup]="form">
            <tidy-row class="field-bottom-padding field-top-padding">
              <tidy-input
                formControlName="email"
                [label]="'Email'"
                [form]="form.controls.email"
                type="email"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid email.'"
                [icon]="'assets/svg/mail.svg'" />
            </tidy-row>
            <tidy-row>
              <tidy-input-international-phone
                formControlName="phone"
                [label]="'Phone'"
                [form]="form.controls.phone"
                [inputMode]="'numeric'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid phone.'"
                [icon]="'assets/svg/phone-portrait.svg'"
                [initialMask]="{ mask: '[00000000000000000000000]' }"
                (countryCodeChange)="onCountryCodeChange($event)" />
            </tidy-row>
          </form>
        </tidy-card>
      }
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/car.svg'"
              class="title-size" />
            <tidy-text
              [header]="'How to Park'" />
            <tidy-text
              [body]="'Add Photo'"
              (action)="getImg('parking')"
              class="link" />
          </tidy-row>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/car.svg'"
              [label]="'What kind of parking?'"
              [form]="form.controls.paid_parking"
              formControlName="paid_parking"
              [items]="parkingTypes"
              (optionChange)="clearFields()" />
          </tidy-row>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/location.svg'"
              [label]="'What kind of spot?'"
              [form]="form.controls.parking_spot"
              formControlName="parking_spot"
              [items]="form.controls.paid_parking.value ? paidParkingSpots : freeParkingSpots" />
          </tidy-row>
          @if (form.controls.paid_parking.value) {
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/card.svg'"
                [label]="'How will you pay?'"
                [form]="form.controls.parking_pay_with"
                formControlName="parking_pay_with"
                [items]="payOptions" />
            </tidy-row>
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/cash.svg'"
                [label]="'How much will you reimburse?'"
                [form]="form.controls.max_parking_cost"
                formControlName="max_parking_cost"
                [items]="maxCostOptions" />
            </tidy-row>
          }
          <tidy-row class="field-top-padding">
            <tidy-input
              [icon]="'assets/svg/create.svg'"
              [label]="'Any notes to help park?'"
              formControlName="parking_notes"
              [form]="form.controls.parking_notes" />
          </tidy-row>
          <photo-caption
            [photoUrls]="parkingPhotoUrls"
            (deletePhoto)="confirmDelete($event)"
            [type]="'parking'" />
        </form>
      </tidy-card>
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/unlock.svg'"
              class="title-size" />
            <tidy-text
              [header]="'How to Get In'" />
            <tidy-text
              [body]="'Add Photo'"
              (action)="getImg('access')"
              class="link" />
          </tidy-row>
          <tidy-row class="field-top-padding">
            <tidy-textarea
              [icon]="'assets/svg/key.svg'"
              [label]="'How do they access the property?'"
              formControlName="home_access"
              [form]="form.controls.home_access" />
          </tidy-row>
          <photo-caption
            [photoUrls]="accessPhotoUrls"
            (deletePhoto)="confirmDelete($event)"
            [type]="'access'" />
          @if (hasLockDevicesIntegrated) {
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Smart Lock Integrated: The RemoteLock code will be available for the pro the day of the job.'" />
            </tidy-row>
          }
        </form>
      </tidy-card>
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/lock.svg'"
              class="title-size" />
            <tidy-text
              [header]="'How to Close Up'" />
            <tidy-text
              class="link"
              [body]="'Add Photo'"
              (action)="getImg('closing')" />
          </tidy-row>
          <tidy-row class="field-top-padding">
            <tidy-textarea
              [icon]="'assets/svg/lock-closed.svg'"
              [label]="'What should they do as they leave?'"
              formControlName="home_close"
              [form]="form.controls.home_close" />
          </tidy-row>
          <photo-caption
            [photoUrls]="closingPhotoUrls"
            (deletePhoto)="confirmDelete($event)"
            [type]="'closing'" />
          @if (hasLockDevicesIntegrated) {
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Smart Lock Integrated: The RemoteLock code will be available for the pro the day of the job.'" />
            </tidy-row>
          }
        </form>
      </tidy-card>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-button
        [action]="boundSave"
        [text]="page?.button"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
